/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */
    close: 'خروج',
    send_more_get_better_rates: 'بیشتر بفرستید، نرخ بهتری بگیرید',

    /* Module special vocabulary */
    ramps: {
        menu: {
            index: 'رمپ‌ها',
            create: 'رمپ جدید',
            list: 'رمپ‌ها'
        },
        table_titles: {
            id: 'شناسه',
            from_currency: 'ارز مبدأ',
            on_ramp_operator: 'اپراتور آن-رمپ',
            on_ramp_exchange: 'صرافی آن-رمپ',
            on_ramp_margin: 'حاشیه آن-رمپ',
            asset: 'دارایی',
            off_ramp_operator: 'اپراتور آف-رمپ',
            off_ramp_exchange: 'صرافی آف-رمپ',
            off_ramp_margin: 'حاشیه آف-رمپ',
            to_currency: 'ارز مقصد',
            min_transfer_amount: 'حداقل مبلغ انتقال',
            max_transfer_amount: 'حداکثر مبلغ انتقال',
            max_monthly_transfer: 'محدودیت ماهانه',
            annual_limit: 'محدودیت سالانه',
            welcome_reward: 'هدیه پیشواز',
            service_fee: 'کارمزد خدمات',
            decimals: 'اعشار',
            exchange_rate: 'نرخ ارز',
            status: 'وضعیت',
            permission: 'مجوز',
            transfer_time: "مدت زمان انتقال",
            setting: 'ویرایش / حذف',
        },
        tiers: {
            index: 'سطوح',
            create: 'جدید',
            edit: 'ویرایش سطح',
            table_titles: {
                id: 'شناسه',
                amount: 'حداقل مبلغ',
                customer_level: 'سطح مشتری',
                on_ramp_discount: 'تخفیف آن-رمپ',
                off_ramp_discount: 'تخفیف آف-رمپ',
                exchange_rate: 'نرخ ارز',
                created_at: 'ایجاد شده در',
                updated_at: 'به‌روزرسانی شده در',
                setting: 'حذف'
            }
        },
        edit: 'ویرایش رمپ',
        confirm: 'تأیید',
        remove: 'حذف',
    },
    transfer_limits: {
        id: 'شناسه',
        from: 'از',
        to: 'به',
        from_country: 'از کشور',
        to_country: 'به کشور',
        monthly_limit: 'سقف ماهانه',
        annual_limit: 'سقف سالانه',
    },
    calculator: {
        you_send: 'مبلغ ارسالی مبدأ',
        recipient_gets: 'مبلغ دریافتی مقصد',
        service_fee: 'کارمزد',
        reward: 'پاداش',
        rewards: 'هدایا',
        unusable_rewards: 'هدایای غیرقابل استفاده',
        welcome_reward: 'تخفیف‌ها',
        total_to_pay: 'مبلغ قابل پرداخت',
        transfer_time: 'مدت زمان انتقال',
        offer: 'نرخ ویژه',
        who_should_receive_this_offer: 'چه کسی این تخفیف را دریافت کند؟',
        you_can_use_your_x_symbol_when_you_pay_in_symbol_only: 'شما تنها زمانی می‌توانید از {total} {symbol} خود استفاده کنید که به {symbol} پرداخت کنید',
        the_minimum_order_size_to_redeem_the_reward_is_currency_symbol: 'حداقل مقدار سفارش برای اخد پاداش {x} {symbol} می‌باشد.',
        i_pay_x_symbol_less: 'من {x} کمتر پرداخت کنم.',
        rebit_pays_x_more: 'ربیت {x} بیشتر پرداخت کند.',
        i_pay_n_fees_recipient_gets_x: 'من {origin} + کارمزد را پرداخت می‌کنم، گیرنده {dest} دریافت کند.',
        i_pay_n_fees_recipient_exactly_gets_x: 'من {origin} {plus_fees} را پرداخت می‌کنم، گیرنده دقیقاً {dest} دریافت کند.',
        plus_fees: '+ کارمزد',
        errors: {
            sending_amount_range: 'مبلغ ارسالی باید بین {min} تا {max} {currency} باشد.',
        },
        standard_rate: 'نرخ استاندارد',
        above: 'بالای',
        you_can_also_type_here: 'می‌توانید مبلغ را در اینجا تایپ کنید.',
        select_currency_of_discount: 'مبلغ تخفیف را انتخاب نمایید',
        transfer_time_disclaimer: '<p>زمان انتقال شامل تعطیلات بانکی گیرنده نمی‌شود. همچنین واریزها ممکن است به دلایل مختلفی به تأخیر بیافتند:</p>'
            + '<ul>'
            + '<li>نوع خدمات انتخاب شده</li>'
            + '<li>مبلغ ارسالی</li>'
            + '<li>کشور مقصد</li>'
            + '<li>موجودی در دسترس ارز</li>'
            + '<li>الزامات قانونی و شناسایی</li>'
            + '<li>مسائل مربوط به حمایت از مشتری</li>'
            + '<li>محدودیت‌های تحویل نظیر ساعات کاری نمایندگی و تفاوت‌های منطقه زمانی</li>'
            + '</ul>'
            + '<p>برای جزئیات بیشتر به شرایط و ضوابط ما مراجعه کنید.</p>',
    }
}
